import { storageMng } from "../helper/StorageMng";
 
// export async function customFetch(input: RequestInfo, init: RequestInit = {}) { 
//   const headers = new Headers(init.headers || {});
//   const isFormData = typeof FormData !== "undefined" && init.body instanceof FormData;
//   const token = storageMng.getِAccessToken();
//    if (token) {
//       headers.set("Authorization", `Bearer ${token}`); 
//     }

//   if (isFormData) {
//     // Critical: let the browser set multipart boundary automatically
//     headers.delete("Content-Type");
//   } else {
//     // JSON (or anything non-FormData)
//     if (!headers.has("Content-Type")) {
//       headers.set("Content-Type", "application/json");
//     }
   

//     if (init.body && typeof init.body !== "string") {
//       init.body = JSON.stringify(init.body);
//     }
//   }
 

//   return fetch(input, { ...init, headers });
// }

export class ApiException extends Error {
  status: number;
  body?: any;

  constructor(message: string, status: number, body?: any) {
    super(message);
    this.status = status;
    this.body = body;
  }
}

export async function customFetch(url: string, init: RequestInit = {} ) {
   const headers = new Headers(init.headers || {});
   const isFormData = typeof FormData !== "undefined" && init.body instanceof FormData;
   const token = storageMng.getِAccessToken();
   if (token) {
       headers.set("Authorization", `Bearer ${token}`); 
   }

  if (isFormData) {
    // Critical: let the browser set multipart boundary automatically
    headers.delete("Content-Type");
  } else {
    // JSON (or anything non-FormData)
    if (!headers.has("Content-Type")) {
      headers.set("Content-Type", "application/json");
    }
    
    if (init.body && typeof init.body !== "string") {
      init.body = JSON.stringify(init.body);
    }
  }
  
  const res = await fetch(url,  { ...init, headers });

  if (res.status === 401) {
    // Session expired or the token was rejected by the server. Clear the stale session and
    // bounce to login so the user re-authenticates cleanly instead of hitting silent
    // failures (e.g. the notifications poll 401'ing in the background). Guard against a
    // redirect loop when we're already on the login page.
    storageMng.clearStorage();
    if (typeof window !== "undefined" && !window.location.pathname.startsWith("/login")) {
      window.location.assign("/login?sessionExpired=1");
    }
    throw new ApiException("HTTP 401 Unauthorized", 401, null);
  }

  if (!res.ok) {
    const contentType = res.headers.get("content-type") || "";
    let body: any = null;

    try {
      body = contentType.includes("application/json")
        ? await res.json()
        : await res.text();
    } catch {
      // ignore parsing errors
    }

    console.error("API ERROR:", {
      url,
      status: res.status,
      statusText: res.statusText,
      body
    });

    throw new ApiException(
      `HTTP ${res.status} ${res.statusText}`,
      res.status,
      body
    );
  }

  return res;
}
